import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TutorCancelledDialogResult } from '../../models/leap-v2-attendance.model';

@Component({
  selector: 'leap-v2-tutor-cancelled-dialog',
  templateUrl: './leap-v2-tutor-cancelled-dialog.component.html',
  styleUrls: ['./leap-v2-tutor-cancelled-dialog.component.css'],
  standalone: false,
})
export class LeapV2TutorCancelledDialogComponent {
  reason = '';
  comments = '';

  readonly reasons = ['Sick', 'Technical', 'Holiday', 'Other'];

  get isValid(): boolean {
    return !!this.reason && !!this.comments.trim();
  }

  constructor(public dialogRef: MatDialogRef<LeapV2TutorCancelledDialogComponent>) {}

  submit(): void {
    if (!this.isValid) return;
    const result: TutorCancelledDialogResult = {
      reason: this.reason,
      comments: this.comments.trim(),
    };
    this.dialogRef.close(result);
  }
}
